import { Button, Drawer, Form, Popover, Tooltip } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/app";
import { CONSTANT } from "../../../config/Constant";
import { InfoCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import AskReason from "./Component/AskReason";
import LogHistory from "./Component/LogHistory";
import {
  getEmailSupportViewStatusList,
  getEmailSupportViewStatusLog,
} from "../../../store/SendEmailSupportSlice";
import { camelCaseString } from "../../../config/Global";

const SendAsteriskViewStatus: React.FC<any> = (props) => {
  const { handleViewStatus, openViewStatusDrawer, openViewStatusData } = props;
  const dispatch: AppDispatch = useDispatch();
  // const data= [
  // 	{
  // 		"_id": "66840d4ecd9a7213bc528451f",
  // 		"provider_name": "AA-test",
  // 		"network_identity": "10",
  // 		"status": "Pending",
  // 		"reason": 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum"',
  // 		"providerId": "1",
  // 		"userId": "1",
  // 	},
  // 	{
  // 		"_id": "66840d4ecd9a7213bc52381f",
  // 		"provider_name": "AA-AA - test",
  // 		"network_identity": "11",
  // 		"status": "In progress",
  // 		"reason": 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32. The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.',
  // 		"providerId": "2",
  // 		"userId": "2",
  // 	},
  // 	{
  // 		"_id": "66840d4ecd9a7213bc523821",
  // 		"provider_name": "AD-Paycall",
  // 		"network_identity": "33232",
  // 		"status": "Cancelled",
  // 		"reason": 'Contrary to popular belief, Lorem Ipsum is not simply random text.',
  // 		"providerId": "3",
  // 		"userId": "3",
  // 	},
  // 	{
  // 		"_id": "66840d4ecd9a7213bc523820",
  // 		"provider_name": "AB-AB - Testing",
  // 		"network_identity": "12",
  // 		"status": "Completed",
  // 		"providerId": "4",
  // 		"userId": "4",
  // 	},

  // ]
  const close = () => {
    handleViewStatus();
    setListData([]);
  };
  const [listData, setListData] = useState<any>([]);
  const [visible, setVisible] = useState<any>(false);
  const [visibleLog, setVisibleLog] = useState<any>(false);
  const [logData, setLogData] = useState<any>();
  const [fileList, setFileList] = useState<any>([]);

  const [form] = Form.useForm();

  const getViewStatusList = useCallback(
    (id: string) => {
      const payload = {
        id: id,
      };
      dispatch(getEmailSupportViewStatusList(payload))
        .then((res: any) => {
          setListData(res?.data?.data);
        })
        .catch((error: any) => {
          console.warn("error", error);
          setListData([]);
        });
    },
    [dispatch]
  );
  const getStatusLog = useCallback(
    (data: any) => {
      const payload = {
        supportId: data._id,
        userId: data.userId,
        providerId: data.ProviderId,
      };
      dispatch(getEmailSupportViewStatusLog(payload))
        .then((res: any) => {
          setVisibleLog(true);
          setLogData(res?.data);
        })
        .catch((error: any) => {
          console.warn("error", error);
          setVisibleLog(false);
          setLogData([]);
        });
    },
    [dispatch]
  );

  useEffect(() => {
    if (openViewStatusData?._id) {
      getViewStatusList(openViewStatusData?._id);
    }
  }, [getViewStatusList, openViewStatusData]);

  const TextWithTooltip = (data: any) => {
    if (data && data?.length > 50) {
      return (
        <span>
          <Popover overlayClassName="desTooltip" title={data} trigger={"hover"}>
            <span style={{ cursor: "pointer" }}>{data.slice(0, 50)}...</span>
          </Popover>
        </span>
      );
    } else {
      return <span>{data}</span>;
    }
  };

  const openReasonModal = (data: any) => {
    setVisible(data);
  };
  const closeReasonModal = () => {
    setVisible(false);
    setFileList([]);
    form.resetFields();
  };

  const openLogDrawer = (data: any) => {
    getStatusLog(data);
    setVisibleLog(true);
  };

  const closeLogDrawer = () => {
    setVisibleLog(false);
    setLogData([]);
  };

  const statusList = (data) => {
    return (
      <>
        <thead>
          <tr>
            <th style={{ width: "10%" }}>Provider</th>
            <th style={{ width: "10%" }}>Network Identity</th>
            <th style={{ width: "10%" }}>Status</th>
            <th style={{ width: "30%" }}>Description</th>
            <th style={{ width: "30%" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any) => {
              return (
                <tr key={item._id}>
                  <td>{item.provider_name}</td>
                  <td>{item.network_identity}</td>
                  <td>
                    {item.status
                      ? camelCaseString(item.status)
                      : CONSTANT.NO_DATA_FOUND}
                  </td>
                  <td>
                    {!item?.reason || item?.reason === "" ? (
                      CONSTANT.NO_MSG_FROM_PROVIDER
                    ) : item?.reason.length > 5 ? (
                      <>{TextWithTooltip(item.reason)}</>
                    ) : (
                      item.reason
                    )}
                  </td>
                  <td>
                    <span className="mr-5">
                      {item.status !== "completed" ? (
                        <Tooltip title="Send Again">
                          <Button
                            icon={<InfoCircleOutlined />}
                            onClick={() => openReasonModal(item)}
                            className="iconBtn"
                            type="default"
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Send Again">
                          <Button
                            icon={<InfoCircleOutlined />}
                            disabled
                            className="iconBtn"
                            type="default"
                          />
                        </Tooltip>
                      )}
                    </span>
                    <span className="mr-5">
                      <Tooltip title="View Status Log">
                        <Button
                          icon={<ClockCircleOutlined />}
                          onClick={() => openLogDrawer(item)}
                          className="iconBtn"
                          type="default"
                        />
                      </Tooltip>
                    </span>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5}>{CONSTANT.NO_DATA_FOUND}</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <>
      <Drawer
        open={openViewStatusDrawer}
        destroyOnClose
        width={1200}
        onClose={close}
        footer={false}
        className="addModal"
        title={`View Send Email Support`}
      >
        <table className="reportTable" width={"100%"}>
          {statusList(listData)}
        </table>
      </Drawer>
      <AskReason
        visible={visible}
        closeReasonModal={closeReasonModal}
        fileList={fileList}
        setFileList={setFileList}
        setVisible={setVisible}
      />
      <LogHistory
        visibleLog={visibleLog}
        logData={logData}
        closeLogDrawer={closeLogDrawer}
      />
    </>
  );
};
export default SendAsteriskViewStatus;
